import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import apiInstance from "../../config/api";
import { updatePostCount } from "../user/userReducer";

export const deletePost = createAsyncThunk('post/delete', async ({ userId, postId }, { rejectWithValue, dispatch }) => {
    try {
        const request = await apiInstance.delete(`/files/api/Uploads/single/${postId}`)
        const response = request.data
        // console.log('delete post response ', response)
        if (response.status === 'success') {
            dispatch(updatePostCount({ actionType: "remove" }))
            return postId
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        // console.log('delete post error ', error.message)
        toast.error('Error deleting post')
        return rejectWithValue(postId)
    }
})

export const getUserFeed = createAsyncThunk('post/feed', async (_, { getState }) => {
    try {
        const state = getState()
        const nextPage = state.post?.pagination?.nextPage
        // const limit = 4

        const querry = {
            ...(nextPage ? { page: nextPage } : {}),
            // ...(limit ? {limit: limit} : {} )
        }
        const request = await apiInstance.get("/api/admin/uploads", {
            params: querry
        })
        const response = request.data
        // console.log("post store; ", response)
        if (response.status === 'success') {
            return { posts: response.posts, pagination: response.pagination }
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        // console.log('post error; ', error)
        throw new Error(error.message)
    }
})

export const getMyPost = createAsyncThunk('post/get-my-post', async (userId) => {
    try {
        const request = await apiInstance.get(`/files/api/uploads/${userId}`)
        const response = request.data
        if (response.message === 'Posts retrieved successfully') {
            return response.posts
        } else if (response === 'There are no uploads for this user.') {
            return []
        }
        else {
            throw new Error(response?.message)
        }
    }
    catch (error) {
        // console.log('get my post error ', error.message)
        throw new Error(error.message)
    }
})

export const getUserPost = createAsyncThunk('post/get-user-post', async (userId) => {
    try {
        const request = await apiInstance.get(`/files/api/uploads/${userId}`)
        const response = request.data
        if (response.message === 'Posts retrieved successfully') {
            return response.posts
        } else {
            // console.log('like error ', response.message)
            return
        }
    }
    catch (error) {
        // console.log('like error ', error.message)
        throw new Error(error.message)
    }
})

export const getPostById = async (postId) => {
    try {
        const request = await apiInstance.get(`/files/api/uploads/single/${postId}`)
        const response = request.data

        // console.log('get post by id response ', response)
        if (response.status === "success") {
            return response.post
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        // console.log('error getting post by id ', error.message)
        throw new Error(error.message)
    }
}

export const likePost = createAsyncThunk('post/like', async (postId) => {
    try {
        const request = await apiInstance.post(`/api/post/like/${postId}`)
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            // console.log('like error ', response.message)
        }
    }
    catch (error) {
        // console.log('like error ', error.message)
    }
})

export const unlikePost = createAsyncThunk('post/unlike', async (postId) => {
    try {
        const request = await apiInstance.post(`/api/post/unlike/${postId}`)
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            // console.log('like error ', response.message)
        }
    }
    catch (error) {
        // console.log('like error ', error.message)
    }
})

export const savePost = createAsyncThunk('post/save', async ({ postId, post }) => {
    try {
        const request = await apiInstance.post(`/api/save-post/${postId}/save`)
        const response = request.data
        if (response.status === 'success') {
            toast.success('post saved successfully!')
            return { isSaved: true, post: post }
        } else {
            throw new Error(response.message)
        }
    } catch (error) {
        throw new Error(error.message)
    }
})

export const unsavePost = createAsyncThunk('post/unsave', async (postId) => {
    try {
        const request = await apiInstance.post(`/api/save-post/${postId}/unsave`)
        const response = request.data
        if (response.status === 'success') {
            toast.success('post unsaved successfully!')
            return { unSaved: true, postId }
        } else {
            throw new Error(response.message)
        }
    } catch (error) {
        throw new Error(error.message)
    }
})

export const getSavedPost = createAsyncThunk('post/get-save-post', async (postId) => {
    try {
        const request = await apiInstance.get("/api/save-post/")
        const response = request.data
        if (response.status === 'success') {
            return response.savedPosts
        } else {
            throw new Error(response.message)
        }
    } catch (error) {
        throw new Error(error.message)
    }
})